export default "__VITE_PUBLIC_ASSET__e47f90f1__"